import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetsummarypage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { BudgetSummaryPage } = await import(
        /* webpackChunkName: "BudgetSummaryPage" */ '../../../components/pages/private/BudgetSummaryPage'
      )
      return {
        default: BudgetSummaryPage,
      }
    })}
    exact
    key={paths.budgetSummary}
    path={paths.budgetSummary}
  />,
]
